import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';
import { fetchConditionSuccess } from '../../../store/actions/condition';
import { getStyles, translate, checkValidity, createArray } from '../../../shared/utility';

import Input from '../../../components/UI/Input/Input';
import Button from '../../../components/UI/Button/Button';
import Logo from '../../../components/Logo/Logo';
import Modal from '../../../components/UI/Modal/Modal';

import localStyles from './Signup.scss';
const styles = getStyles(localStyles);

class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            controls: {
                firstName: {
                    elementConfig: {
                        type: 'text',
                        name: 'firstName',
                        id: 'signup-firstname'
                    },
                    modifiers: ['stretch'],
                    label: 'formControls.firstName',
                    value: '',
                    validation: {
                        required: true,
                        minLength: 1,
                        maxLength: 128
                    },
                    valid: false,
                    touched: false
                },
                email: {
                    elementConfig: {
                        type: 'email',
                        name: 'email',
                        id: 'singup-email'
                    },
                    modifiers: ['stretch'],
                    label: 'formControls.emailLong',
                    value: '',
                    validation: {
                        required: true,
                        isEmail: true
                    },
                    valid: false,
                    touched: false
                }
            },
            formIsValid: false
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.isSignupOpen !== this.props.isSignupOpen && !this.props.isSignupOpen && this.props.signupSuccess) {
            this.props.onFetchConditionSuccess('signup', false);
        }
    }

    handleChange = (event) => {
        const updatedFormElement = {...this.state.controls[event.target.name], ...{
            value: event.target.value,
            valid: checkValidity(event.target.value, this.state.controls[event.target.name].validation),
            touched: true
        }};

        const updatedControls = {...this.state.controls, ...{
            [event.target.name]: updatedFormElement
        }};

        let formIsValid = true;
        for (let inputIdentifier in updatedControls) {
            formIsValid = updatedControls[inputIdentifier].valid && formIsValid;
        }

        this.setState({ controls: updatedControls, formIsValid: formIsValid });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.formIsValid) {
            const url = window.location.origin;
            this.props.onSignup(this.state.controls.firstName.value, this.state.controls.email.value, this.props.communityDetailsData.id, url);
        }
    }

    handleModalToggle = (identifier, value, resetPassword) => {
        this.props.onSetGlobalState(identifier, value);

        if (resetPassword && typeof resetPassword === 'boolean') {
            this.props.history.push({ pathname: '/reset-password' });
        }
    }

    handleCloseSignupModal = () => {
        this.props.onSetGlobalState('isSignupOpen', false);
    }

    handleResetPasswordRedirect = () => {
        this.handleCloseSignupModal();

        this.props.history.push({ pathname: '/reset-password' });
    }

    handleOpenLogin = () => {
        this.handleCloseSignupModal();
        this.props.onSetGlobalState('isLoginOpen', true);
    }

    render() {
        const formElementsArray = createArray(this.state.controls);
        const errorMessage = this.props.signupError ? <div className={styles('signup__error', 'c--error')}><p>{this.props.signupError}</p></div> : null;
        const modalTitle = !this.props.signupSuccess ? translate('pages.signup.title', this.props.language) : '';

        const form = (
            <form className={styles('signup__form')} onSubmit={this.handleSubmit}>
                {formElementsArray.map(element => (
                    <Input key={element.id}
                        attrs={element.config.elementConfig}
                        value={element.config.value}

                        modifiers={element.config.modifiers}

                        invalid={!element.config.valid}
                        touched={element.config.touched}

                        required={element.config.validation.required}

                        events={{ change: this.handleChange }}

                        label={translate(element.config.label, this.props.language)}
                        loading={this.props.signupLoading}
                    />
                ))}
                <Button
                    attrs={{type:'submit'}}
                    modifiers={['primary', 'stretch', 'm', 'spaced']}
                    disabled={!this.state.formIsValid}
                    loading={this.props.signupLoading}
                >
                    {translate('pages.signup.button', this.props.language)}
                </Button>
            </form>
        );

        const modalContent = this.props.signupSuccess ? (
            <div className={styles('align--center')}>
                <div className={styles('signup__circle')}>
                    <div className={styles('signup__circle__checkmark')} />
                </div>
                <h3>{translate('pages.signup.successTitle', this.props.language)}</h3>
                <p className={styles('c--text-light')}>{translate('pages.signup.successSubtitle', this.props.language)}</p>
            </div>
        ) : (
            <div className={styles('signup__content')}>
                {errorMessage}
                {form}
                <div className={styles('flex', 'flex--wrap', 'signup__footer')}>

                    <div className={styles('col--100 col__xxs--50')}>
                        <h6>{translate('pages.signup.forgotPasswordTitle', this.props.language)}</h6>
                        <p>
                            <Button
                                modifiers={['text']}
                                classes={styles('c--text-light', 'underline')}
                                events={{ click: this.handleResetPasswordRedirect }}
                                disabled={this.props.signupLoading}
                            >{translate('pages.login.forgotPasswordLink', this.props.language)}</Button>
                        </p>
                    </div>


                    <div className={styles('col--100 col__xxs--50')}>
                        <h6>{translate('pages.signup.loginTitle', this.props.language)}</h6>
                        <p>
                            <Button
                                modifiers={['text']}
                                classes={styles('c--text-light', 'underline')}
                                events={{ click: this.handleOpenLogin }}
                                disabled={this.props.signupLoading}
                            >{translate('pages.signup.loginLink', this.props.language)}</Button>
                        </p>
                    </div>

                    <div className={styles('align--center', 'col--100', 'signup__footer__logo')}>
                        <p className={styles('small c--text-lightest')}>
                            {translate('pages.signup.poweredBy', this.props.language)} <Logo modifiers={['inline']} />
                        </p>
                    </div>

                </div>
            </div>
        );

        return this.props.isSignupOpen ? (
            <Modal
                isOpen={this.props.isSignupOpen}
                close={this.handleCloseSignupModal}
                title={modalTitle}
                noClosing={this.props.signupLoading}
            >
                {modalContent}
            </Modal>
        ) : null;
    }
}

Signup.propTypes = {
    // properties
    history: PropTypes.object.isRequired,
    isSignupOpen: PropTypes.bool.isRequired,
    communityDetailsData: PropTypes.object,
    
    signupSuccess: PropTypes.bool,
    signupLoading: PropTypes.bool,
    signupError: PropTypes.string,

    language: PropTypes.string.isRequired,

    // functions
    onSignup: PropTypes.func.isRequired,
    onSetGlobalState: PropTypes.func.isRequired,
    onFetchConditionSuccess: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        isSignupOpen: state.global.isSignupOpen,
        communityDetailsData: state.details.community.data,

        signupSuccess: state.condition.signup.success,
        signupLoading: state.condition.signup.loading,
        signupError: state.condition.signup.error,

        language: state.global.localization.language
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSignup: (name, email, communityId, url) => dispatch(actions.signup(name, email, communityId, url)),
        onSetGlobalState: (identifier, value) => dispatch(actions.setGlobalState(identifier, value)),
        onFetchConditionSuccess: (identifier, value) => dispatch(fetchConditionSuccess(identifier, value))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Signup));



// WEBPACK FOOTER //
// ./src/containers/User/Signup/Signup.js